var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrawerLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66666 1.16668C3.66666 1.62501 3.29166 2.00001 2.83333 2.00001H1.99999V12H2.83333C3.29166 12 3.66666 12.375 3.66666 12.8333C3.66666 13.2917 3.29166 13.6667 2.83333 13.6667H1.16666C0.708328 13.6667 0.333328 13.2917 0.333328 12.8333V1.16668C0.333328 0.708343 0.708328 0.333344 1.16666 0.333344H2.83333C3.29166 0.333344 3.66666 0.708343 3.66666 1.16668ZM12.0032 3.18734L14.3482 6.52068C14.5566 6.81568 14.5499 7.21151 14.3332 7.49984L11.8332 10.8332C11.6699 11.0515 11.4191 11.1665 11.1657 11.1665C10.9924 11.1665 10.8166 11.1123 10.6666 10.9998C10.2982 10.724 10.2241 10.2015 10.4999 9.83401L12.0007 7.83318H11.9999H5.33324C4.87324 7.83318 4.49991 7.46068 4.49991 6.99984C4.49991 6.53901 4.87324 6.16651 5.33324 6.16651H11.9999C12.0137 6.16651 12.0265 6.17031 12.0393 6.17413C12.0498 6.17725 12.0604 6.18039 12.0716 6.18151L10.6399 4.14568C10.3749 3.76984 10.4657 3.24984 10.8424 2.98484C11.2182 2.71901 11.7382 2.81068 12.0032 3.18734Z",
    fill: "#335C75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerLogout);
export default __webpack_public_path__ + "static/media/DrawerLogout.eeedcaff.svg";
export { ForwardRef as ReactComponent };